import { LabelType } from '~/shared/enums/label-type.enum';

export class LabelPreset {
  id: number;
  name: string;
  generateBarcodes: boolean;
  sourceView: string;
  selectByField: string;
  barcodeField: string;
  nameField: string;
  catalog: boolean;
  custom: boolean;
  twoDimensional: boolean;
  rows: number;
  columns: number;
  reportDefinition: string;
  isPortrait: boolean;
  sortAsc?: boolean;
  selectAll: boolean;
  filterBy: string;
  assetrac: boolean;
  instock: boolean;
  customLabel: boolean;
  labelSizeID: number;
  relatedLabelPresetID?: number;
  selectedFields: string;
  isBarcode: boolean;
  isAsset: boolean;
  isURL?: boolean;
  isQRCode?: boolean;
  Width: number;
  Height: number;
  pageName: string;
  siteId?: number;
  labelType?: LabelType;
  constructor() {
    this.id = 0;
    this.name = "";
    this.generateBarcodes = false;
    this.sourceView = "";
    this.selectByField = "";
    this.barcodeField = "";
    this.nameField = "";
    this.catalog = false;
    this.custom = false;
    this.twoDimensional = false;
    this.rows = 0;
    this.columns = 0;
    this.reportDefinition = "";
    this.isPortrait = false;
    this.sortAsc = false;
    this.selectAll = false;
    this.filterBy = "";
    this.assetrac = false;
    this.instock = false;
    this.customLabel = false;
    this.labelSizeID = 0;
    this.relatedLabelPresetID = null;
    this.selectedFields = "";
    this.isBarcode = false;
    this.isAsset = false;
    this.isURL = false;
    this.isQRCode = false;
    this.Width = 0;
    this.Height = 0;
    this.pageName = "";
    this.siteId = 0;
  }
}
